export default __webpack_public_path__ + "static/media/compiegne9.d5ef4a73.jpg";